import L from "leaflet";

// const startIcon = new L.Icon({
//   iconUrl: require("../assets/img/sourceMarker.svg"),
//   iconRetinaUrl: require("../assets/img/sourceMarker.svg"),
//   iconAnchor: null,
//   popupAnchor: null,
//   shadowUrl: null,
//   shadowSize: null,
//   shadowAnchor: null,
//   iconSize: new L.Point(60, 75),
//   className: "leaflet-div-icon",
// });

const startIcon = new L.divIcon({
  className: "custom-icon__start",
  html: '<img src="/mapIcon/sourceMarker.svg" alt="start icon" />',
});
const destIcon = new L.divIcon({
  className: "custom-icon__end",
  html: '<img src="/mapIcon/destinationMarker.svg" alt="destination icon" />',
});

export { startIcon, destIcon };
